import React, { useState } from 'react';
import { FrequencySelection } from '../../../types/autopar';

interface Props {
  frequencySelection: FrequencySelection;
  frequency: number;
  reservePercent: number;
  onApply: (fs: FrequencySelection, freq: number, reserve: number) => void;
}

export default function OppModelerPanel({ frequencySelection, frequency, reservePercent, onApply }: Props) {
  const [fs, setFs] = useState<FrequencySelection>(frequencySelection);
  const [freqVal, setFreqVal] = useState<number>(frequency);
  const [reserve, setReserve] = useState<number>(reservePercent);

  return (
    <div className='alert alert-info'>
      <strong className='d-block mb-2'>Opportunity Modeler</strong>
      <div className='mb-2'>Ordering more frequently can lower stock levels safely.</div>

      <div className='form-check'>
        <input className='form-check-input' type='radio' name='order' id='order0' checked={fs==='0'} onChange={() => setFs('0')} />
        <label className='form-check-label' htmlFor='order0'>Current order frequency</label>
      </div>
      <div className='form-check'>
        <input className='form-check-input' type='radio' name='order' id='order1' checked={fs==='1'} onChange={() => setFs('1')} />
        <label className='form-check-label' htmlFor='order1'>Twice as often per month</label>
      </div>
      <div className='form-check'>
        <input className='form-check-input' type='radio' name='order' id='order2' checked={fs==='2'} onChange={() => setFs('2')} />
        <label className='form-check-label' htmlFor='order2'>Three times as often per month</label>
      </div>
      <div className='form-check d-flex align-items-center gap-2'>
        <input className='form-check-input' type='radio' name='order' id='order3' checked={fs==='3'} onChange={() => setFs('3')} />
        <label className='form-check-label' htmlFor='order3'>Per week</label>
        <input className='form-control form-control-sm w-auto text-end' type='number' value={fs==='3' ? freqVal : '' as any} onChange={e => setFreqVal(Number(e.target.value))} placeholder='times/week' />
      </div>
      <div className='form-check d-flex align-items-center gap-2'>
        <input className='form-check-input' type='radio' name='order' id='order4' checked={fs==='4'} onChange={() => setFs('4')} />
        <label className='form-check-label' htmlFor='order4'>Per month</label>
        <input className='form-control form-control-sm w-auto text-end' type='number' value={fs==='4' ? freqVal : '' as any} onChange={e => setFreqVal(Number(e.target.value))} placeholder='times/month' />
      </div>

      <div className='mt-3 d-flex align-items-center gap-2'>
        <label className='form-label m-0'>Reserve Margin (%)</label>
        <input className='form-control form-control-sm w-auto text-end' type='number' value={reserve} onChange={e => setReserve(Number(e.target.value))} />
      </div>

      <div className='mt-3'>
        <button className='btn btn-primary' onClick={() => onApply(fs, freqVal || 0, reserve)}>Apply</button>
      </div>
    </div>
  );
}
